<script lang="ts" setup>
const props = defineProps({
  text: {
    type: String,
    require: true,
  },
});

const locationSegments = ref<Array<string | { type: "link"; url: string }>>([]);

onMounted(() => {
  if (props.text) {
    locationSegments.value = parseLocationText(props.text);
  }
});

function parseLocationText(text: string) {
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
  const segments: Array<string | { type: "link"; url: string }> = [];

  const parts = text.split(urlRegex);

  parts.forEach((part) => {
    if (urlRegex.test(part)) {
      if (part.startsWith("www.")) {
        part = "http://" + part;
      }
      segments.push({ type: "link", url: part });
    } else {
      segments.push(part);
    }
  });

  return segments;
}
</script>

<template>
  <span v-for="(segment, index) in locationSegments" :key="index">
    <template v-if="typeof segment === 'string'">
      {{ segment }}
    </template>
    <template v-else>
      <a :href="segment.url" target="_blank" class="text-primary-blue-color hover:underline">
        {{ segment.url }}
      </a>
    </template>
  </span>
</template>

<style lang="scss" scoped>
.session_recap__grid {
  @apply flex flex-col gap-[10px] px-[8px] py-[16px] max-w-full;
  background: var(--grey-light);
  border-radius: 8px;

  .session_recap__split {
    @apply grid gap-[8px];
  }

  section {
    @apply inline-flex px-[8px];

    .session_recap__key {
      @apply flex items-center text-secondary-color text-[14px] min-w-[108px];

      img {
        @apply w-[16px] h-[16px] mr-[4px];
      }
    }
  }
}
</style>
